module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-discovery-and-science-in-hollywood-florida-a39160462c0e34dabea7ef6a2a260cd2.png";